import styled from 'styled-components';

export const StartRatingStyled = styled.div`
  margin: 0 0 30px 0;
  ul {
    margin: 0 0 24px 0;
    padding: 0;
    list-style: none;
    display: flex;

    li {
      margin: 0 20px 0 0;
      cursor: pointer;
      display: flex;
    }
  }
  .error {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: ${(props) => props.theme.verification.red.main};
    padding: 0;
    background: transparent;
    margin-top: 20px;
  }
`;
